import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    title: 'The "Shadow Clause"',
    desc: 'The exact 2-paragraph legal addendum that makes landlords thank you for taking their keys.'
  }, {
    title: 'The 2025 ZIP Code Heatmap',
    desc: 'The only 12 blocks in the US where the numbers actually work right now.'
  }, {
    title: 'The "Furniture-to-Profit" Ratio',
    desc: 'How to furnish a studio for under $3,500 and make it look like a $450/night boutique hotel.'
  }, {
    title: 'The 3-App Autopilot',
    desc: 'How I used AI and automation to remove "tenants, toilets, and termites" from the equation forever.'
  }];
  return <section className="w-full bg-[#0f1724] py-12 md:py-20 px-4 relative" data-id="element-10">
      {/* Gold Divider */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-[#c9a84c]" data-id="element-11"></div>

      <div className="max-w-3xl mx-auto" data-id="element-12">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-2xl md:text-4xl text-[#c9a84c] text-center mb-8 md:mb-12" data-id="element-13">
          What You Get in the Blueprint
        </motion.h2>

        <div className="space-y-3 md:space-y-8" data-id="element-14">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-3 md:gap-4 p-4 md:p-6 rounded-lg hover:bg-[#1a2332] transition-colors duration-300 border border-transparent hover:border-[#c9a84c]/10" data-id="element-15">
              <div className="flex-shrink-0 mt-0.5 md:mt-1" data-id="element-16">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-[#c9a84c]" data-id="element-17" />
              </div>
              <div data-id="element-18">
                <h3 className="text-lg md:text-xl font-bold text-[#c9a84c] mb-1 md:mb-2" data-id="element-19">
                  {benefit.title}
                </h3>
                <p className="text-[#f5f0e8]/80 text-base md:text-lg leading-relaxed" data-id="element-20">
                  {benefit.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}